import React, { useEffect, useMemo, useState } from "react";
import { Container, Col, Row } from "reactstrap";
import SidebarCust from "../../Layouts/SidebarCust";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  bot_details,
  Get_Bot_User_List,
  GET_DB_Connection_for_bot_config,
} from "../../slices/BotDetails/thunk";

import {
  Bot_Thread,
  Bot_Thread_Create,
  Get_Favourite_Prompt_Category,
  Get_Favourite_Prompt_List,
  GET_TABLE_DETAILS,
  group_owner_details,
} from "../../slices/thunks";

import config from "../../config";

import {
  reset_chat_history,
  reset_chat_history_whole,
} from "../../slices/Chat_Cust/reducer";
import { reset_thread_list, reset_thread_reducer } from "../../slices/Thread/reducer";
import { reset_Bot_Details } from "../../slices/BotDetails/reduders";
import { reset_Table_Data } from "../../slices/Table_Details/reducer";
import { change_page } from "../../slices/SideBarCust/reducer";
import { set_bread_crum } from "../../slices/header/reducer";

import Chat from "../Chat";
import Configuration from "../BotSetting/Configuration";
import Knowledge from "../BotSetting/Knowledge";
import BotThreads from "../BotSetting/BotThreads";
import FavoritePrompt from "../BotSetting/FavoritePrompt";
import BotUser from "../BotSetting/BotUser";
import Tool from "../BotSetting/Tool";
import Bot_Description from "../BotSetting/Bot_Description";
import Bot_Instruction from "../BotSetting/Bot_instruction";
import Sample_Question from "../BotSetting/Sample_Question";
import SQL_Instruction from "../BotSetting/SQL_Instruction";
import Bot_Tittle from "./Bot_Tittle";
import Bot_image from "./Bot_image";
import Loader from "../../Components/Common/Loader";


const Bot_Config = () => {
  document.title = "BotSetting | Configuration";
  const dispatch = useDispatch();
  const { state } = useLocation();

  // Redux selectors
  const SidebarCustPage = useSelector((s) => s.SidebarCust.currentPage);
  const BotDetails = useSelector((s) => s.BotDetails.Bot_Details);
  const { selectedthread, temp_selected_thread_title } = useSelector((s) => s.Threads);

  // Local state
  const [_profile_image, set_profile_image] = useState(null);
  const [_profile_image_file, set_profile_image_file] = useState(null);

  // Resolve Bot_ID once (from router state or localStorage)
  const Bot_ID = useMemo(
    () => state?.Bot_ID || localStorage.getItem("Bot_ID") || null,
    [state?.Bot_ID]
  );

  // -----------------------------
  // Mount / Unmount: breadcrumb + full reset on unmount
  // -----------------------------
  useEffect(() => {
    dispatch(set_bread_crum({ title: "BotSetting", pageTitle: "Configuration" }));

    return () => {
      // Run ALL resets when this page unmounts
      dispatch(set_bread_crum({ title: "", pageTitle: "" }));
      dispatch(reset_Table_Data());
      dispatch(reset_chat_history());
      dispatch(reset_thread_list());
      dispatch(reset_thread_reducer());
      dispatch(reset_chat_history_whole());
      dispatch(reset_Bot_Details());
    };
   
  }, []); // run once

  // -----------------------------
  // Initial data fetch when Bot_ID is available
  // -----------------------------
  useEffect(() => {
    if (!Bot_ID) return;

    // Keep minimal resets here to avoid flicker when Bot_ID changes (deep resets are already on unmount)
    // dispatch(reset_Table_Data());

    // Primary bot fetches
    dispatch(bot_details(Bot_ID));
    dispatch(Bot_Thread(Bot_ID));
    // dispatch(Bot_Thread_Create(Bot_ID));

    // Persist current selection
    localStorage.setItem("Bot_ID", Bot_ID);
  }, [Bot_ID, dispatch]);

  // -----------------------------
  // Fire dependent fetches only AFTER BotDetails is populated
  // -----------------------------
  useEffect(() => {
    const resolvedBotId = BotDetails?.Bot_ID || Bot_ID;
    if (!resolvedBotId) return;

    // Lists dependent on Bot
    dispatch(Get_Favourite_Prompt_List({ Bot_ID: resolvedBotId }));
    // dispatch(Get_Bot_User_List({ bot_id: resolvedBotId }));

    // Group-dependent data
    if (BotDetails?.Group_ID) {
      // dispatch(group_owner_details({ group_id: BotDetails.Group_ID , page:1 , per_page:1 }));
      dispatch(Get_Favourite_Prompt_Category({ group_id: BotDetails.Group_ID }));
    }

    // DB-dependent data
    if (BotDetails?.Database_ID) {
      dispatch(
        GET_DB_Connection_for_bot_config({ database_id: BotDetails.Database_ID })
      );
      dispatch(
        GET_TABLE_DETAILS({
          databaseId: BotDetails.Database_ID,
          page_size: config.general_config.PER_PAGE_CONTENT,
          page: 1,
          search_term: "",
          Bot_ID: resolvedBotId,
        })
      );
    }
  }, [ BotDetails , Bot_ID]);

  // -----------------------------
  // Role-based page redirect
  // -----------------------------
  useEffect(() => {
    if (BotDetails?.User_Role === "Viewer") {
      dispatch(change_page("Favourite Prompt"));
    }
  }, [BotDetails?.User_Role, dispatch]);

  // -----------------------------
  // Helpers
  // -----------------------------
  const rolePillClass =
    BotDetails?.User_Role === "BotAdmin"
      ? "bg-admin-button bg-primary-cust-button text-dark"
      : BotDetails?.User_Role === "BotUser"
      ? "bg-info-subtle-cust text-dark"
      : BotDetails?.User_Role === "Viewer"
      ? "bg-warning-cust text-dark"
      : "bg-primary-cust-button text-dark";

  const RolePill = (
    <span style={{ padding: "1px 8px" }} className={`rounded-pill ${rolePillClass}`}>
      {BotDetails?.User_Role}
    </span>
  );

  const showLeftCol =
    SidebarCustPage === "Bot setting" ||
    SidebarCustPage === "Configuration" ||
    SidebarCustPage === "Knowledge" ||
    SidebarCustPage === "Bot threads" ||
    SidebarCustPage === "Favourite Prompt" ||
    SidebarCustPage === "Bot User" ||
    SidebarCustPage === "Tools" ||
    SidebarCustPage === "Bot description" ||
    SidebarCustPage === "Bot instruction" ||
    SidebarCustPage === "SQL Instruction" ||
    SidebarCustPage === "Sample question";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {!BotDetails?.Bot_ID || <SidebarCust />}
          {!BotDetails?.Bot_ID?<Loader/>:<div className="Configuration ml_auto">
            <Row>
              {(SidebarCustPage === "Bot setting" || SidebarCustPage === "Configuration") && (
                <Col className="full_1024" lg={3}>
                  <div className="d-flex mb-2 align-items-center">
                    <Bot_image
                      _profile_image={_profile_image}
                      set_profile_image={set_profile_image}
                      set_profile_image_file={set_profile_image_file}
                    />
                    <Bot_Tittle
                      Bot_Title={BotDetails?.Bot_Title}
                      Bot_Group={BotDetails?.Group_Name}
                      Bot_Assistant={BotDetails?.Assets_ID}
                    />
                  </div>
                  {BotDetails?.User_Role !== "Viewer" && (
                    <Configuration _profile_image_file={_profile_image_file} />
                  )}
                </Col>
              )}

              {SidebarCustPage === "Knowledge" &&
                BotDetails?.User_Role !== "BotUser" &&
                BotDetails?.User_Role !== "Viewer" && (
                  <Col>
                    <div className="mobile-flex">
                      <div className="d-flex mb-2 align-items-center">
                        <Bot_image
                          _profile_image={_profile_image}
                          set_profile_image={set_profile_image}
                          set_profile_image_file={set_profile_image_file}
                        />
                        <div className="flex-grow-1 ms-3">
                          <Bot_Tittle
                            Bot_Title={BotDetails?.Bot_Title}
                            Bot_Group={BotDetails?.Group_Name}
                            Bot_Assistant={BotDetails?.Assets_ID}
                          />
                        </div>
                      </div>
                      <div className="mb-3">{RolePill}</div>
                    </div>
                    <Knowledge />
                  </Col>
                )}

              {SidebarCustPage === "Bot threads" && (
                <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    <div className="mb-3">{RolePill}</div>
                  </div>
                  <BotThreads />
                </Col>
              )}

              {SidebarCustPage === "Favourite Prompt" && (
                <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    <div className="mb-3">{RolePill}</div>
                  </div>
                  <FavoritePrompt />
                </Col>
              )}

              {SidebarCustPage === "Bot User" && (
                <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    <div className="mb-3">{RolePill}</div>
                  </div>
                  <BotUser />
                </Col>
              )}

              {SidebarCustPage === "Tools" && (
                <>
                {/* <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    {RolePill && <div className="mb-3">{RolePill}</div>}
                  </div>
                  <div className="hard_code mt-3">
                      <section class="tools-info" aria-labelledby="tools-title">
  <h2 id="tools-title">Tools</h2>
  <p>
    Enhance your bot by enabling the tools you need. Each tool adds a specific skill so the bot can deliver richer, more accurate answers.
    Toggle a switch on the right to turn a tool on or off.
  </p>

  <ul>
    <li>
      <strong>Google Map</strong> — Find nearby places, get directions, and explore maps.
    </li>
    <li>
      <strong>Open Weather Map</strong> — Get real-time weather updates, forecasts, and current conditions.
    </li>
    <li>
      <strong>Wikipedia Retriever</strong> — Pull concise, reliable knowledge from Wikipedia into the chat.
    </li>
    <li>
      <strong>YouTube Search</strong> — Search and fetch top YouTube videos directly within the conversation.
    </li>
  </ul>

  <p class="hint">
    Tip: Enable only what you need for your use case to keep responses fast and focused.
  </p>
</section> 

                    </div>
                </Col>
*/}
                      
                {/* <Col lg={9}> */}
                  {/* <Tool /> */}
                {/* </Col> */}
                </>
              )}

              {SidebarCustPage === "Bot description" && (
                <>
                <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    {RolePill && <div>{RolePill}</div>}
                  </div>
                   <div className="hard_code mt-3">
                      <section class="bot-description" aria-labelledby="bot-description-title">
  <h2 id="bot-description-title">Bot Description</h2>
  <p>
    This section is for adding a short introduction about your bot. It does not affect the bot’s functionality, but helps users understand its purpose and features.
  </p>
  <ul>
    <li>Explain what your bot can do (e.g., maps, weather, knowledge, videos).</li>
    <li>Keep it simple, friendly, and easy to read.</li>
    <li>Helps new users know what to expect before they start chatting.</li>
  </ul>
  <p class="hint">
    💡 Tip: Write in a way that makes users excited to try your bot.
  </p>
</section>

                    </div>
                </Col>
                
                <Col lg={9}>
                <Bot_Description />
                </Col>
                </>
              )}

              {SidebarCustPage === "Bot instruction" && (
                <>
                  <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    {RolePill && <div>{RolePill}</div>}
                  </div> 
                  <div className="hard_code mt-3">
                      <section class="bot-instruction" aria-labelledby="bot-instruction-title">
  <h2 id="bot-instruction-title">Bot Instruction</h2>
  <p>
    Define how your bot should behave and respond. Instructions in this section directly influence the bot’s answers.
  </p>
  <ul>
    <li>Set the <strong>tone of voice</strong> (e.g., friendly, formal, concise).</li>
    <li>Include <strong>rules or guidelines</strong> (e.g., “always explain with examples,” “summarize in 3 bullet points”).</li>
    <li>Adapt the bot for your specific <strong>use case</strong> (e.g., support agent, tutor, finance advisor).</li>
  </ul>
  <p class="hint">
    💡 Tip: The clearer your instructions, the more consistent and useful your bot’s responses will be.
  </p>
</section>

                    </div>                  
                </Col>
                <Col lg={9}>
                  <Bot_Instruction />
                </Col>
                </>
              )}

              {SidebarCustPage === "SQL Instruction" && BotDetails?.Type === "DBLink" && (
                <>
                <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    {RolePill && <div>{RolePill}</div>}
                  </div>
                  <div className="hard_code mt-3">
                  <section class="sql-instruction" aria-labelledby="sql-instruction-title">
  <h2 id="sql-instruction-title">SQL Instruction</h2>
  <p>
    Use this section to provide special guidance or constraints for how SQL queries should be generated or executed by the AI.
  </p>
  <ul>
    <li>Specify <strong>filters</strong>, <strong>custom logic</strong>, or <strong>business rules</strong> 
        (e.g., “only show active users,” “limit results to top 10,” “order by sales descending”).</li>
    <li>Ensure queries follow your <strong>database structure</strong> and requirements.</li>
    <li>If left blank, the AI will create queries based on the user’s question using default logic.</li>
  </ul>
  <p class="hint">
    💡 Tip: Add clear and simple instructions here to improve the accuracy and relevance of generated queries.
  </p>
</section>
                    </div> 
                </Col>
                <Col lg={9}>
                  <SQL_Instruction />
                </Col>
                </>
              )}

              {/* {SidebarCustPage === "Sample question" && (
                <Col lg={3}>
                  <div className="mobile-flex">
                    <div className="d-flex mb-2 align-items-center">
                      <Bot_image
                        _profile_image={_profile_image}
                        set_profile_image={set_profile_image}
                        set_profile_image_file={set_profile_image_file}
                      />
                      <div className="flex-grow-1 ms-3">
                        <Bot_Tittle
                          Bot_Title={BotDetails?.Bot_Title}
                          Bot_Group={BotDetails?.Group_Name}
                          Bot_Assistant={BotDetails?.Assets_ID}
                        />
                      </div>
                    </div>
                    <div>{RolePill}</div>
                  </div>
                  <Sample_Question />
                </Col>
              )} */}
              {SidebarCustPage === "Sample question" && (
                 <>
                   <Col lg={3}>
                    <div className="mobile-flex">
                      <div className="d-flex mb-2 align-items-center">
                        <Bot_image
                          _profile_image={_profile_image}
                          set_profile_image={set_profile_image}
                          set_profile_image_file={set_profile_image_file}
                        />
                        <div className="flex-grow-1 ms-3">
                          <Bot_Tittle
                            Bot_Title={BotDetails?.Bot_Title}
                            Bot_Group={BotDetails?.Group_Name}
                            Bot_Assistant={BotDetails?.Assets_ID}
                          />
                        </div>
                      </div>

                      {RolePill && <div>{RolePill}</div>}
                    </div>  
                    <div className="hard_code mt-3">
                      <section class="sample-questions" aria-labelledby="sample-questions-title">
  <h2 id="sample-questions-title">Sample Question</h2>
  <p>
    Add example questions here to guide users on how to interact with the bot. These will appear as clickable prompts that users can try instantly.
  </p>
  <ul>
    <li>Helps new users discover the bot’s capabilities.</li>
    <li>Makes the chat more interactive with ready-to-use queries.</li>
    <li>Use short, clear questions like <em>“What can you do?”</em>, <em>“Show me today’s weather”</em>, or <em>“Find nearby restaurants”</em>.</li>
  </ul>
  <p class="hint">
    💡 Tip: Choose questions that best demonstrate your bot’s core features.
  </p>
</section>

                    </div>                  
                  </Col>
                  <Col lg={9}>
                      <Sample_Question />
                  </Col>
                 </>
                )}

              {/* Right chat pane (hidden on Knowledge full-width view) */}
              {SidebarCustPage !== "Knowledge" && SidebarCustPage !== "Sample question" && SidebarCustPage !== "Bot instruction" && SidebarCustPage !== "Bot description" &&  SidebarCustPage !== "Tools" && SidebarCustPage !== "SQL Instruction" && (
                <Col lg={9}>
                  <div className="chat_button">
                    <div className="chat_thread_title">
                      {selectedthread?.title || temp_selected_thread_title}
                    </div>
                    {!(selectedthread === null || selectedthread === undefined) && ""}
                  </div>
                  {!(selectedthread === null || selectedthread === undefined) ? (
                    <div className="chat-part">
                      <Chat />
                    </div>
                  ) : (
                    ""
                  )}
                </Col>
              )}
            </Row>
          </div>}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Bot_Config;
